
import renderMath from "../math/renderMath.tsx";

export default (documentTree: any[]) => {

	const recursiveRender = (tree: any[]) => {
		const fragment = new DocumentFragment();

		for (const item of tree) {
			switch (item.type) {
				case ("text"): {
					fragment.append(new Text(item.string));
					break;
				} case ("math"): {
					fragment.append(
						<math
							attr:display={item.displayBlock ? "block" : null}
							attr:displaystyle={(item.displayBlock !== item.displayStyle) ? item.displayStyle : null}
						>
							{renderMath(item.content)}
						</math>
					);
					break;
				} case ("newLine"): {
					fragment.append(<br />);
					break;
				} case ("paragraph"): {
					fragment.append(
						<p class:bottom-margin={item.bottomMargin}>
							{recursiveRender(item.content)}
						</p>
					);
					break;
				} case ("bold"): {
					fragment.append(<strong>{recursiveRender(item.content)}</strong>);
					break;
				} case ("italic"): {
					fragment.append(<em>{recursiveRender(item.content)}</em>);
					break;
				} case ("underline"): {
					fragment.append(<u>{recursiveRender(item.content)}</u>);
					break;
				} case ("code"): {
					fragment.append(<code>{recursiveRender(item.content)}</code>);
					break;
				} case ("heading"): {
					const headingElement = document.createElement("h" + Math.min(item.headingLevel, 6));
					headingElement.append(recursiveRender(item.content));
					fragment.append(headingElement);
					break;
				}
			}
		}

		return fragment;
	};

	return recursiveRender(documentTree);
};
